import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { useToast } from '../../hooks/use-toast';
import { useConfig } from '../../config/ConfigContext';

const ProductCard = ({ product, index = 0 }) => {
  const { dispatch } = useCart();
  const { toast } = useToast();
  const { isFeatureEnabled } = useConfig();

  // Helper to get the correct thumbnail image
  const thumbnailImage = (product.images && product.images.length > 0)
    ? (product.images[product.thumbnail_index] || product.images[0])
    : '/api/placeholder/400/400';

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();

    dispatch({
      type: 'ADD_TO_CART',
      payload: {
        product_id: product.id,
        name: product.name,
        price: product.price,
        image: thumbnailImage,
        quantity: 1,
        size: 'Contact for Price'
      }
    });

    toast({
      title: "Added to cart",
      description: `${product.name} has been added to your cart.`,
    });
  };

  return (
    <Link to={`/product/${product.id}`} className="group block">
      <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden">
        {/* Product Image */}
        <div className="relative overflow-hidden aspect-square">
          <img
            src={thumbnailImage}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover"
          />

          {/* Add to Cart Overlay Button - Only show if feature enabled */}
          {isFeatureEnabled('showAddToCart') && (
            <div className="absolute bottom-4 right-4 z-10">
              <button
                className="bg-white rounded-full p-3 shadow-lg hover:bg-brand-blue hover:text-white text-brand-blue transition-colors"
                onClick={handleAddToCart}
                aria-label="Add to cart"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                </svg>
              </button>
            </div>
          )}

          {/* Foam/Spring Badge for Mattresses */}
          {(['TITANIUM MEMORY', 'LORD', 'SPECIAL', 'JAKKAR', 'LANA', 'NORMAL', 'NICE', '1er CHOIX', 'GLORIA', 'MILLENIUM', 'POCKET TITANIUM', 'TITANIUM POCKET', 'VELORA'].includes(product.name)) && product.in_stock && (
            <div className="absolute top-4 left-4">
              {['TITANIUM MEMORY', 'LORD', 'SPECIAL', 'JAKKAR', 'SYNERGY', 'VELORA'].includes(product.name) ? (
                <span className="bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                  FOAM
                </span>
              ) : (
                <span className="bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                  SPRING
                </span>
              )}
            </div>
          )}

          {/* Out of Stock Badge */}
          {!product.in_stock && (
            <div className="absolute top-4 left-4">
              <span className="bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                Out of Stock
              </span>
            </div>
          )}
        </div>

        {/* Product Info */}
        <div className="p-4">
          <h3 className="font-semibold text-gray-900 mb-1 line-clamp-2 group-hover:text-brand-blue transition-colors">
            {product.name}
          </h3>

          {/* Price */}
          <div className="flex items-center justify-between">
            <span className="text-base md:text-lg font-bold text-gray-900">
              {product.price > 1 ? `$${product.price.toFixed(2)}` : 'Contact for Price'}
            </span>
            {product.in_stock && product.price > 1 && (
              <span className="text-xs text-green-600 font-semibold">In Stock</span>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
